const DEFAULT_VIDEO_MAIN_COLOR = "skyblue";
const DEFAULT_VIDEO_TITLE_COLOR = "white";
const DEFAULT_VIDEO_TITLE = "kurzer Einleitungssatz - z.B. “Wir suchen Fachinformatiker (w/m/d)”";
const DEFAULT_VIDEO_OUTRO_TEXT = "Jetzt bei uns durchstarten";
const DEFAULT_VIDEO_CTA_TEXT = "Jetzt bewerben";
export const DEFAULT_VIDEO_OUTRO_PLACEHOLDER = "Abschlusstext - z.B. “Jetzt bei uns durchstarten”";
export const DEFAULT_VIDEO_CTA_PLACEHOLDER = "Aufforderung - z.B. “Jetzt bewerben”";
const DEFAULT_VIDEO_BENEFITS = [
  "Benefit - z.B. “flexible Arbeitszeiten”",
  "Benefit - z.B. “flexible Arbeitszeiten”",
  "Benefit - z.B. “flexible Arbeitszeiten”"
];
const DEFAULT_VIDEO_LOGO_URL =
  "https://res.cloudinary.com/dyiuxe5fa/image/upload/v1644940387/tb-campaign-photos/none/1150_0002_Logo_Alpha_klima_srgeq1.png";
const DEFAULT_VIDEO_IMAGE_URL =
  "https://res.cloudinary.com/dyiuxe5fa/image/upload/v1644938658/generated/apollon_image_1_vnizhc.jpg";
const DEFAULT_VIDEO_AUDIO_URL =
  "https://storage.googleapis.com/talentbait-tts-files/Jingles/Abenteurlich.mp3";

export const DEFAULT_PLAYER_DATA = {
  title: DEFAULT_VIDEO_TITLE,
  primaryTextColor: DEFAULT_VIDEO_TITLE_COLOR,
  primaryBackgroundColor: DEFAULT_VIDEO_MAIN_COLOR,
  outroText: DEFAULT_VIDEO_OUTRO_TEXT,
  CTAText: DEFAULT_VIDEO_CTA_TEXT,
  benefits: DEFAULT_VIDEO_BENEFITS,
  logoUrl: DEFAULT_VIDEO_LOGO_URL,
  imageUrl: DEFAULT_VIDEO_IMAGE_URL,
  audioUrl: DEFAULT_VIDEO_AUDIO_URL
};

export const VIDEO_FPS = 15;
export const TIKTOK_VIDEO_FPS = 30;
